<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row">
            </div>
        </base-header>

        <!-- <div class="container-fluid mt--7" v-if="modal.creditPackage == true">
            <div class="row">
                <div class="col">
                    <credit-packages-table></credit-packages-table>
                </div>
            </div>
        </div> -->

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <app-versions-table></app-versions-table>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import AppVersionsTable from './Tables/AppVersionsTable';
  export default {
    name: 'tables',
    components: {
      AppVersionsTable
    },
    data() {
        return {

        }
    },
    mounted() {
        $('#settingsToggle').attr("aria-expanded","true");
        $('#settings').show();
    },
    // computed: {
    //   totalCreditPackage()
    //   {
    //     return this.totalCreditPackage;
    //   },
    //   totalCreditPackageTransaction()
    //   {
    //     return this.totalCreditPackageTransaction;
    //   }
    // },
    methods: {
    }
  };
</script>
<style></style>
